import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Safari session storage fix
if (typeof Storage !== 'undefined') {
  try {
    sessionStorage.setItem('test', 'test');
    sessionStorage.removeItem('test');
  } catch (e) {
    console.warn('Safari: Session storage not accessible, using fallback');
  }
}

// Safari compatibility fixes
if (typeof window !== 'undefined') {
  // Polyfill for Safari's missing support for some modern features
  if (!window.requestIdleCallback) {
    window.requestIdleCallback = (callback) => {
      return setTimeout(callback, 1);
    };
  }
  
  if (!window.cancelIdleCallback) {
    window.cancelIdleCallback = (id) => {
      clearTimeout(id);
    };
  }
  
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
